import { QueryHookOptions } from '@apollo/client';

import { useFeaturesQuery } from 'apollo/queries/autogenerate/hooks';
import {
  FeaturesQuery,
  FeaturesQueryVariables,
} from 'apollo/queries/autogenerate/operations';
import Mixpanel from 'shared/vendor/Mixpanel';

type Options = QueryHookOptions<FeaturesQuery, FeaturesQueryVariables>;

const useFeatureFlags = (options: Options = {}) => {
  const { data } = useFeaturesQuery({
    ...options,
    onCompleted(result) {
      const props = { 'Feature Flags': result.features.enabled };

      Mixpanel.setUserProperties(props);
      Mixpanel.registerSuperProperties(props);
      options.onCompleted?.(result);
    },
  });

  return data;
};

export default useFeatureFlags;
